import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { createStructuredSelector } from 'reselect';
import injectSaga from 'utils/injectSaga';
import { PRODUCTS_KEY } from 'containers/PrimoProducts/constants';
import primoProductsSaga from 'containers/PrimoProducts/saga';
import {
  selectProductsData,
  selectFamilyProductBundleData,
  selectProductsAreFetching,
  selectProductsTotalCount,
  selectProductCategories,
} from 'containers/PrimoProducts/selectors';
import {
  selectPromotionId,
  selectCartItems,
  selectPromotionLoading,
} from 'containers/Cart/selectors';
import {
  loadFamilyProductBundles,
  loadMerchandizedProducts,
  loadProductCategories,
} from 'containers/PrimoProducts/actions';
import { addPromotion, loadCartProducts } from 'containers/Cart/actions';
import { CART_PAGE_KEY } from 'containers/Cart/constants';
import cartSaga from 'containers/Cart/saga';
import {
  selectAcquisitionVariables,
  selectCostcoAccount,
  selectSsrReqRoute,
} from 'containers/Landing/selectors';
import withContentful from 'containers/Landing/withContenfull';
import { pages } from 'containers/Landing/constants';
import { withContent } from 'components/Content';
import QuickShopBasePage from './QuickShopBasePage';
import withLanding from '../Landing/withLanding';
import { pages as PAGES } from '../Landing/constants';

const mapStateToProps = createStructuredSelector({
  areProductsFetching: selectProductsAreFetching(),
  productCategories: selectProductCategories(),
  products: selectProductsData(true),
  familyProductBundles: selectFamilyProductBundleData(),
  totalCount: selectProductsTotalCount(),
  promotionId: selectPromotionId(),
  isPromotionLoading: selectPromotionLoading(),
  cartItems: selectCartItems(),
  costcoAccount: selectCostcoAccount(),
  acquisitionVariables: selectAcquisitionVariables(),
  ssrReqRoute: selectSsrReqRoute(),
});
const CONTENT_KEYS = {
  familyProductBundles: 'Family Product Bundles',
};
const mapDispatchToProps = {
  addPromotion,
  loadFamilyProductBundles,
  loadMerchandizedProducts,
  loadProductCategories,
  loadCartProducts,
};

const withProductsSaga = injectSaga({
  key: PRODUCTS_KEY,
  saga: primoProductsSaga,
});
const withCartSaga = injectSaga({ key: CART_PAGE_KEY, saga: cartSaga });

const QuickShopPage = compose(
  withLanding(PAGES.quickShop),
  withContent(CONTENT_KEYS),
  withRouter,
  withProductsSaga,
  withCartSaga,
  connect(mapStateToProps, mapDispatchToProps),
)(QuickShopBasePage);

export default withContentful(pages.quickShop)(QuickShopPage);
